import React, { Component } from 'react';
import './Header.css';
import HeaderCarousel from './HeaderCarousel/HeaderCarousel';
class Header extends Component {
	state = {};
	render() {
		return <HeaderCarousel />;
	}
}

export default Header;
